(function () {
    "use strict";

    angular.module("app").component("pscisScopeLevelsEditor", {
        templateUrl: "@/pscis/pscis-scope-levels-editor.template.html",
        controller: ViewController,
        controllerAs: "vm",
        bindings: {
            allowedScopes: "<",
            allowedLevels: "<",
            scopeLevels: "=",
            validation: "<",
            codeTypes: "<",
        }
    });

    ViewController.$inject = [];
    function ViewController() {
        const LEVEL_NONE = 1;
        const SCOPE_NTL = 'NTL';
        const SCOPE_NATO = 'NATO';

        const scopeLevelMap = {
            'NTL': [],
            'NATO': [],
            'EU': [],
            'ESA': []
        };

        const vm = this;

        // Lifecycle hook to initialize logic if needed
        vm.$onInit = function () {
            // Ensure request objects exist to prevent errors on render
            if (!vm.scopeLevels) {
                vm.scopeLevels = [];
            }

            // Populate the map with existing scopes/levels
            vm.scopeLevels.forEach(item => {
                // Check if the scope exists to avoid errors if an unexpected scope appears
                if (scopeLevelMap[item.Scope]) {
                    scopeLevelMap[item.Scope].push(item.Level);
                }
            });
        };

        vm.isLevelSelected = function (scope, level) {
            if (scopeLevelMap[scope]) {
                const levelsSet = new Set(scopeLevelMap[scope] || []);
                return levelsSet.has(level);
            }
            return false;
        };

        // Selection handler
        vm.toggleLevel = function (scope, level) {
            if (level === LEVEL_NONE || scope === SCOPE_NTL || scope === SCOPE_NATO) {
                scopeLevelMap[scope] = [level];
            } else {
                // Initialize as a Set for O(1) constant-time lookups and deletions
                const levelsSet = new Set(scopeLevelMap[scope] || []);

                // Always ensure LEVEL_NONE is removed when selecting other levels
                levelsSet.delete(LEVEL_NONE);

                // Toggle the target level
                if (levelsSet.has(level)) {
                    levelsSet.delete(level);
                } else {
                    levelsSet.add(level);
                }

                // Convert the Set back to an array
                scopeLevelMap[scope] = Array.from(levelsSet);
            }

            vm.scopeLevels = updateScopeLevels();
        };

        function updateScopeLevels() {
            const flattened = [];

            vm.allowedScopes.forEach(function (item) {
                if (item.Scope !== 'EU' && item.Scope !== 'ESA') {
                    if (item.Level) {
                        flattened.push({
                            Scope: item.Scope,
                            Level: item.Level
                        });
                    }
                }
            });

            Object.entries(scopeLevelMap).forEach(([scope, levels]) => {
                levels.forEach(level => {
                    flattened.push({
                        Scope: scope,
                        Level: level
                    });
                });
            });

            return flattened;
        };
    }
})();